// Mock data for DonorsHouse portal

export const BLOOD_TYPES = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];

export const ORGANS = [
  { id: 'kidney', name: 'Kidney', livingDonation: true, livesToSave: 2 },
  { id: 'liver', name: 'Liver (partial)', livingDonation: true, livesToSave: 1 },
  { id: 'heart', name: 'Heart', livingDonation: false, livesToSave: 1 },
  { id: 'lungs', name: 'Lungs', livingDonation: false, livesToSave: 2 },
  { id: 'pancreas', name: 'Pancreas', livingDonation: false, livesToSave: 1 },
  { id: 'intestines', name: 'Intestines', livingDonation: false, livesToSave: 1 },
  { id: 'corneas', name: 'Corneas', livingDonation: false, livesToSave: 2 },
  { id: 'tissues', name: 'Tissues', livingDonation: false, livesToSave: 0 }
];

export const mockBloodRequests = [
  {
    id: '1',
    patientName: 'Anonymous',
    bloodType: 'O-',
    urgency: 'critical',
    unitsNeeded: 3,
    country: 'United States',
    city: 'New York',
    hospital: 'Mount Sinai Hospital',
    reason: 'Emergency surgery',
    contactPhone: '+1 555-0123',
    status: 'active',
    createdAt: new Date('2025-01-15'),
    expiresAt: new Date('2025-01-20')
  },
  {
    id: '2',
    patientName: 'John D.',
    bloodType: 'A+',
    urgency: 'high',
    unitsNeeded: 2,
    country: 'United Kingdom',
    city: 'London',
    hospital: 'Royal London Hospital',
    reason: 'Accident victim',
    contactPhone: '+44 20 7123 4567',
    status: 'active',
    createdAt: new Date('2025-01-16'),
    expiresAt: new Date('2025-01-22')
  },
  {
    id: '3',
    patientName: 'Maria S.',
    bloodType: 'B+',
    urgency: 'medium',
    unitsNeeded: 1,
    country: 'India',
    city: 'Mumbai',
    hospital: 'Tata Memorial Hospital',
    reason: 'Cancer treatment',
    contactPhone: '+91 22 2417 7000',
    status: 'active',
    createdAt: new Date('2025-01-14'),
    expiresAt: new Date('2025-01-25')
  }
];

export const mockDonationCenters = [
  {
    id: '1',
    name: 'New York Blood Center',
    type: 'Blood Bank',
    country: 'United States',
    city: 'New York',
    address: '310 E 67th St, New York, NY 10065',
    phone: '+1 212-570-3000',
    email: 'info@nybc.org',
    website: 'https://nybc.org',
    hours: 'Mon-Fri 8AM-7PM, Sat-Sun 8AM-5PM',
    walkIn: true,
    verified: true,
    lat: 40.7649,
    lng: -73.9593
  },
  {
    id: '2',
    name: 'NHS Blood Donation Centre',
    type: 'Blood Bank',
    country: 'United Kingdom',
    city: 'London',
    address: 'Margaret St, London W1W 8RH',
    phone: '+44 300 123 23 23',
    email: 'contact@nhsbt.nhs.uk',
    website: 'https://blood.co.uk',
    hours: 'Mon-Fri 9AM-6PM',
    walkIn: true,
    verified: true,
    lat: 51.5194,
    lng: -0.1388
  },
  {
    id: '3',
    name: 'Tata Memorial Hospital Blood Bank',
    type: 'Hospital',
    country: 'India',
    city: 'Mumbai',
    address: 'Dr E Borges Rd, Parel East, Mumbai 400012',
    phone: '+91 22 2417 7000',
    email: 'bloodbank@tmc.gov.in',
    website: 'https://tmc.gov.in',
    hours: '24/7',
    walkIn: true,
    verified: true,
    lat: 19.0030,
    lng: 72.8470
  }
];

export const mockCityStats = [
  { city: 'Mumbai', country: 'India', donors: 3200, lat: 19.0760, lng: 72.8777 },
  { city: 'New York', country: 'United States', donors: 2500, lat: 40.7128, lng: -74.0060 },
  { city: 'Tokyo', country: 'Japan', donors: 2100, lat: 35.6762, lng: 139.6503 },
  { city: 'London', country: 'United Kingdom', donors: 1800, lat: 51.5074, lng: -0.1278 },
  { city: 'São Paulo', country: 'Brazil', donors: 1500, lat: -23.5505, lng: -46.6333 },
  { city: 'Berlin', country: 'Germany', donors: 980, lat: 52.5200, lng: 13.4050 },
  { city: 'Paris', country: 'France', donors: 890, lat: 48.8566, lng: 2.3522 },
  { city: 'Sydney', country: 'Australia', donors: 750, lat: -33.8688, lng: 151.2093 },
  { city: 'Dubai', country: 'United Arab Emirates', donors: 620, lat: 25.2048, lng: 55.2708 },
  { city: 'Singapore', country: 'Singapore', donors: 580, lat: 1.3521, lng: 103.8198 }
];

export const mockCountryRegulations = [
  {
    code: 'US',
    name: 'United States',
    consentType: 'Opt-In',
    euthanasiaLegal: 'Partial',
    euthanasiaDetails: 'Legal in 10 states (OR, WA, CA, CO, VT, NJ, HI, ME, NM, MT)',
    organDonationLegal: 'Legal',
    livingDonationAllowed: true,
    minAge: 18,
    bloodDonationInterval: 56,
    regulatoryBody: 'UNOS (United Network for Organ Sharing)',
    website: 'https://unos.org',
    organsAllowed: ['kidney', 'liver', 'heart', 'lungs', 'pancreas', 'intestines', 'corneas', 'skin', 'bone', 'heart valves'],
    bloodRegulations: 'Must be at least 17 years old (16 with parental consent in some states), weigh at least 110 pounds, and be in good health. 56-day wait between whole blood donations, 7 days for platelets.',
    foreignNationalPolicy: 'Non-residents can receive transplants but are limited to 5% of total organ supply. Must demonstrate ability to pay and have appropriate follow-up care in home country.',
    risks: 'Living kidney donors face 0.03% mortality risk. Long-term risks include slightly elevated blood pressure and reduced kidney function. Comprehensive evaluation required before donation.',
    waitingTimes: {
      kidney: '3-5 years',
      liver: '11 months',
      heart: '4-6 months',
      lung: '4-6 months',
      pancreas: '1-2 years',
      cornea: '1-2 weeks'
    },
    statistics: {
      totalTransplantsPerYear: 46632,
      kidneyTransplants: 27000,
      liverTransplants: 10000,
      heartTransplants: 4500,
      lungTransplants: 2800,
      waitingList: 103000,
      deceasedDonors: 15000,
      livingDonors: 6500
    },
    visaRequired: true,
    visaType: 'B-2 Tourist/Medical Visa',
    visaProcessingTime: '3-5 weeks',
    visaExtension: true,
    visaRequirements: 'Proof of medical appointment, financial ability to pay for treatment, intent to return home, valid passport',
    euthanasiaStates: [
      { name: 'Oregon', status: 'Legal', types: 'physician-assisted suicide' },
      { name: 'Washington', status: 'Legal', types: 'physician-assisted suicide' },
      { name: 'California', status: 'Legal', types: 'physician-assisted suicide' },
      { name: 'Colorado', status: 'Legal', types: 'physician-assisted suicide' },
      { name: 'Vermont', status: 'Legal', types: 'physician-assisted suicide' },
      { name: 'New Jersey', status: 'Legal', types: 'physician-assisted suicide' },
      { name: 'Hawaii', status: 'Legal', types: 'physician-assisted suicide' },
      { name: 'Maine', status: 'Legal', types: 'physician-assisted suicide' },
      { name: 'New Mexico', status: 'Legal', types: 'physician-assisted suicide' },
      { name: 'Montana', status: 'Legal', types: 'physician-assisted suicide', requirements: 'Court ruling (Baxter v. Montana)' }
    ],
    euthanasiaRequirements: 'Terminal illness with 6-month prognosis, mental competency, multiple requests, waiting period varies by state',
    organDonationAfterEuthanasia: 'Allowed'
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    consentType: 'Opt-Out',
    euthanasiaLegal: 'Illegal',
    organDonationLegal: 'Legal',
    livingDonationAllowed: true,
    minAge: 18,
    bloodDonationInterval: 90,
    regulatoryBody: 'NHS Blood and Transplant',
    website: 'https://nhsbt.nhs.uk'
  },
  {
    code: 'IN',
    name: 'India',
    consentType: 'Opt-In',
    euthanasiaLegal: 'Partial',
    euthanasiaDetails: 'Passive euthanasia legal since 2018',
    organDonationLegal: 'Legal',
    livingDonationAllowed: true,
    minAge: 18,
    bloodDonationInterval: 90,
    regulatoryBody: 'National Organ and Tissue Transplant Organisation (NOTTO)',
    website: 'https://notto.mohfw.gov.in'
  }
];

export const allCountries = [
  { code: 'AR', name: 'Argentina', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'AU', name: 'Australia', consentType: 'Opt-In', euthanasiaLegal: 'Partial', euthanasiaDetails: 'Legal in some states' },
  { code: 'AT', name: 'Austria', consentType: 'Opt-Out', euthanasiaLegal: 'Legal' },
  { code: 'BD', name: 'Bangladesh', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'BE', name: 'Belgium', consentType: 'Opt-Out', euthanasiaLegal: 'Legal' },
  { code: 'BR', name: 'Brazil', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'BG', name: 'Bulgaria', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'CA', name: 'Canada', consentType: 'Opt-In', euthanasiaLegal: 'Legal' },
  { code: 'CL', name: 'Chile', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'CO', name: 'Colombia', consentType: 'Opt-Out', euthanasiaLegal: 'Legal' },
  { code: 'CR', name: 'Costa Rica', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'HR', name: 'Croatia', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'CU', name: 'Cuba', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'CY', name: 'Cyprus', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'CZ', name: 'Czech Republic', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'DK', name: 'Denmark', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'EC', name: 'Ecuador', consentType: 'Opt-Out', euthanasiaLegal: 'Partial' },
  { code: 'EG', name: 'Egypt', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'EE', name: 'Estonia', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'FI', name: 'Finland', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'FR', name: 'France', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'DE', name: 'Germany', consentType: 'Opt-In', euthanasiaLegal: 'Partial' },
  { code: 'GR', name: 'Greece', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'GT', name: 'Guatemala', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'HU', name: 'Hungary', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'IS', name: 'Iceland', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'IN', name: 'India', consentType: 'Opt-In', euthanasiaLegal: 'Partial' },
  { code: 'ID', name: 'Indonesia', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'IE', name: 'Ireland', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'IL', name: 'Israel', consentType: 'Opt-In', euthanasiaLegal: 'Partial' },
  { code: 'IT', name: 'Italy', consentType: 'Opt-In', euthanasiaLegal: 'Partial' },
  { code: 'JM', name: 'Jamaica', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'JP', name: 'Japan', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'KE', name: 'Kenya', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'LV', name: 'Latvia', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'LT', name: 'Lithuania', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'LU', name: 'Luxembourg', consentType: 'Opt-Out', euthanasiaLegal: 'Legal' },
  { code: 'MY', name: 'Malaysia', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'MT', name: 'Malta', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'MX', name: 'Mexico', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'MA', name: 'Morocco', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'NP', name: 'Nepal', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'NL', name: 'Netherlands', consentType: 'Opt-Out', euthanasiaLegal: 'Legal' },
  { code: 'NZ', name: 'New Zealand', consentType: 'Opt-In', euthanasiaLegal: 'Legal' },
  { code: 'NG', name: 'Nigeria', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'NO', name: 'Norway', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'PK', name: 'Pakistan', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'PA', name: 'Panama', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'PE', name: 'Peru', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'PH', name: 'Philippines', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'PL', name: 'Poland', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'PT', name: 'Portugal', consentType: 'Opt-Out', euthanasiaLegal: 'Legal' },
  { code: 'RO', name: 'Romania', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'SA', name: 'Saudi Arabia', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'SG', name: 'Singapore', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'SK', name: 'Slovakia', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'SI', name: 'Slovenia', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'ZA', name: 'South Africa', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'KR', name: 'South Korea', consentType: 'Opt-In', euthanasiaLegal: 'Partial' },
  { code: 'ES', name: 'Spain', consentType: 'Opt-Out', euthanasiaLegal: 'Legal' },
  { code: 'LK', name: 'Sri Lanka', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'SE', name: 'Sweden', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'CH', name: 'Switzerland', consentType: 'Opt-Out', euthanasiaLegal: 'Partial' },
  { code: 'TH', name: 'Thailand', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'TN', name: 'Tunisia', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'TR', name: 'Turkey', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'UA', name: 'Ukraine', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'AE', name: 'United Arab Emirates', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'GB', name: 'United Kingdom', consentType: 'Opt-Out', euthanasiaLegal: 'Illegal' },
  { code: 'US', name: 'United States', consentType: 'Opt-In', euthanasiaLegal: 'Partial', euthanasiaDetails: 'Legal in 10 states' },
  { code: 'UY', name: 'Uruguay', consentType: 'Opt-Out', euthanasiaLegal: 'Partial' },
  { code: 'VE', name: 'Venezuela', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' },
  { code: 'VN', name: 'Vietnam', consentType: 'Opt-In', euthanasiaLegal: 'Illegal' }
];

export const mockSponsors = [
  {
    id: '1',
    name: 'New Abilities Foundation',
    tier: 'Platinum',
    logo: 'https://newabilities.org/logo.png',
    website: 'https://newabilities.org',
    description: 'A 501(c)(3) nonprofit organization supporting global health initiatives'
  },
  {
    id: '2',
    name: 'Kosansh Solutions Inc',
    tier: 'Gold',
    logo: null,
    website: 'https://kosansh.com',
    description: 'Technology solutions company supporting healthcare initiatives'
  }
];

export const mockUser = {
  id: 'user1',
  name: 'Generic Donor',
  email: 'donor@example.com',
  bloodType: 'A+',
  country: 'United States',
  city: 'New York',
  phone: '+1 555-0100',
  profilePicture: null,
  address: '123 Main St, New York, NY 10001',
  isBloodDonor: true,
  isOrganDonor: true,
  organsPledged: ['kidney', 'liver', 'corneas'],
  bodyDonation: true,
  emergencyContact: {
    name: 'Emergency Contact',
    phone: '+1 555-0101',
    relationship: 'Spouse'
  },
  role: 'user',
  inviteCode: 'GENERIC2025',
  joinedVia: 'direct',
  createdAt: new Date('2024-06-15')
};

export const globalStats = {
  registeredDonors: 8,
  activeRequests: 6,
  activeCities: 10,
  livesSaved: 31960,
  organPledges: 0,
  countriesRepresented: 195
};